module.exports = __webpack_public_path__ + "img/WL-logo.b320717e.svg";